import { render, staticRenderFns } from "./WebSocketDemo.vue?vue&type=template&id=12e5edcf&scoped=true"
import script from "./WebSocketDemo.vue?vue&type=script&lang=js"
export * from "./WebSocketDemo.vue?vue&type=script&lang=js"
import style0 from "./WebSocketDemo.vue?vue&type=style&index=0&id=12e5edcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5edcf",
  null
  
)

export default component.exports